import './css/Vendor.scss';
import { Observable, Subject, ReplaySubject, of, concat, from, merge, combineLatest, throwError, forkJoin } from 'rxjs';
import { debounceTime, switchMap, distinctUntilChanged, map, startWith, takeUntil, tap, catchError, reduce, filter, toArray, concatMap, mergeMap, shareReplay, share, delay, take, finalize } from 'rxjs/operators';
const RxJs = {
    Observable,
    Subject,
    ReplaySubject,
    of,
    debounceTime,
    switchMap,
    combineLatest,
    distinctUntilChanged,
    map,
    startWith,
    takeUntil,
    tap,
    catchError,
    concat,
    reduce,
    filter,
    toArray,
    concatMap,
    mergeMap,
    merge,
    from,
    shareReplay,
    share,
    throwError,
    delay,
    take,
    finalize,
    forkJoin
};
if (typeof window !== 'undefined') {
    window.RxJs = RxJs;
}
// dont forget to add exports to vendor.d.ts
export { RxJs };
